import activeOffers from './modules/active-offers'
import activities from './modules/activities'
import baseChanges from './modules/base-changes'
import creditProcesses from './modules/credit-processes'
import customers from './modules/customers'
import external from './modules/external'
import funnels from './modules/funnels'
import reports from './modules/reports'
import leadsReceptions from './modules/leads-receptions'
import settings from './modules/settings'

import { setDefaultFiltersBeforeEnter } from 'asteroid'

const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'Root',
        path: '',
        redirect: { name: 'Dashboard' }
      },

      {
        name: 'Dashboard',
        path: '/dashboard',
        beforeEnter: setDefaultFiltersBeforeEnter,
        component: () => import('pages/Dashboard.vue')
      },

      ...activeOffers,

      ...activities,

      ...baseChanges,

      ...creditProcesses,

      ...customers,

      ...funnels,

      ...reports,

      ...leadsReceptions,

      ...settings
    ]
  },

  {
    // o boot "chatwoot" faz o uso deste path, caso atualize, alterar lá.
    path: '/external',
    name: 'ExternalLayout',
    component: () => import('layouts/ExternalLayout.vue'),
    meta: { requiresAuth: false },
    children: external
  }
]

export default routes
